import { Phone, MessageSquare, MapPin, CalendarCheck, Mail, Clock, Printer } from "lucide-react";
import { ConsultationForm } from "../components/ConsultationForm";
import { BOOKING_URL, CHERRY_URL, PHONE_DISPLAY, PHONE_TEL, FAX_DISPLAY, IMG, EMAIL, ADDRESS_LINE1, ADDRESS_LINE2, MAPS_URL, HOURS } from "../data/site";

const WAYS = [
  { icon: CalendarCheck, title: "Book Online", text: "Reserve your time instantly", href: BOOKING_URL, id: "book" },
  { icon: Phone, title: "Call", text: PHONE_DISPLAY, href: `tel:${PHONE_TEL}`, id: "call" },
  { icon: MessageSquare, title: "Text", text: PHONE_DISPLAY, href: `sms:${PHONE_TEL}`, id: "text" },
];

export default function Contact() {
  return (
    <main data-testid="contact-page">
      <section className="grid lg:grid-cols-2">
        <div className="h-[340px] overflow-hidden lg:h-[720px]"><img src={IMG.museNeck} alt="Lux Veritae muse" className="h-full w-full object-cover object-top" /></div>
        <div className="flex flex-col justify-center bg-white px-6 py-20 md:px-16 lg:py-32">
          <p className="kicker rise">Private Consultation</p>
          <h1 className="font-display rise d1 mt-4 text-5xl font-light leading-[1.05] text-neutral-950 sm:text-6xl">Begin your<br /><em>Lux Veritae</em> plan.</h1>
          <p className="rise d2 mt-6 max-w-md text-base font-light leading-relaxed text-neutral-600">Tell us about your goals. We'll compose a personalized plan with treatment options, packages and timeline — discreetly, and on your schedule.</p>
          <div className="rise d3 mt-10 grid gap-px bg-neutral-200 sm:grid-cols-3">
            {WAYS.map((w) => (
              <a key={w.id} href={w.href} target={w.id === "book" ? "_blank" : undefined} rel="noreferrer" className="group bg-white p-6 transition-colors hover:bg-neutral-950" data-testid={`contact-way-${w.id}`}>
                <w.icon size={18} strokeWidth={1.25} className="text-neutral-950 group-hover:text-white" />
                <p className="mt-4 text-[10px] uppercase tracking-[0.25em] text-neutral-500 group-hover:text-neutral-400">{w.title}</p>
                <p className="mt-1 text-sm text-neutral-950 group-hover:text-white">{w.text}</p>
              </a>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-[hsl(var(--mist))] py-20 md:py-28">
        <div className="mx-auto grid max-w-[1400px] gap-16 px-4 md:px-8 lg:grid-cols-[1.5fr_1fr]">
          <ConsultationForm />
          <aside className="space-y-10">
            <div>
              <p className="kicker">Visit</p>
              <a href={MAPS_URL} target="_blank" rel="noreferrer" data-testid="contact-address-link" className="font-display mt-3 flex items-start gap-2 text-2xl leading-snug text-neutral-950 hover:text-neutral-600"><MapPin size={18} strokeWidth={1.25} className="mt-1.5 shrink-0" /><span>{ADDRESS_LINE1}<br />{ADDRESS_LINE2}</span></a>
              <p className="mt-3 text-sm font-light text-neutral-600">Serving Scottsdale and the surrounding communities.</p>
              <p className="mt-6 flex items-center gap-2 text-sm text-neutral-800"><Clock size={15} strokeWidth={1.25} /> {HOURS}</p>
              <a href={`mailto:${EMAIL}`} data-testid="contact-email-link" className="mt-3 flex items-center gap-2 text-sm text-neutral-800 hover:text-neutral-500"><Mail size={15} strokeWidth={1.25} /> {EMAIL}</a>
              <p className="mt-3 flex items-center gap-2 text-sm text-neutral-800" data-testid="contact-fax"><Printer size={15} strokeWidth={1.25} /> Fax {FAX_DISPLAY}</p>
            </div>
            <div className="border-t border-neutral-300 pt-10">
              <p className="kicker">Financing</p>
              <p className="mt-3 text-sm font-light leading-relaxed text-neutral-600">Pay over time for comprehensive treatment plans with Cherry.</p>
              <a href={CHERRY_URL} target="_blank" rel="noreferrer" className="link-under mt-5" data-testid="contact-cherry-link">Apply with Cherry</a>
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
}
